import { render, staticRenderFns } from "./ManagedUsers.vue?vue&type=template&id=53045c9b&"
import script from "./ManagedUsers.vue?vue&type=script&lang=js&"
export * from "./ManagedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports